import React from "react"
import Icon1 from "@/assets/grid_background_icons/Wolontariat_ilustracja_serce_1.svg"
import styled from "styled-components"
import GridContainerRectangles from "@/components/common/GridContainerRectangles"
import GridContainer from "@/components/common/GridContainer"
import { getCssSizeValue, getFontSize, getHtmlFromRedactorField } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { useIsMobile, useIsTablet } from "@/hooks/useDevice"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const TilesRectangleGridAdditionalTopSectionContainer = styled.div`
	position: relative;
	min-height: calc(100vw / 8 * 36);
	border-top: 1px solid ${({ theme }) => theme.colors.antiflashWhite};
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		min-height: calc(100vw / 8 * 15);
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		min-height: calc(100vw / 16 * 10);
	}
`

const BackgroundGrid = styled(GridContainerRectangles)`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	grid-template-columns: repeat(8, 1fr);
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		grid-template-columns: repeat(16, 1fr);
	}

	.icon {
		position: absolute;
		width: calc(100vw / 8);
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			width: calc(100vw / 16);
		}
	}

	.icon-1 {
		top: calc(100vw * 13 / 8);
		right: 0;
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
			top: calc(100vw * 5 / 8);
			right: calc(100vw / 8);
		}
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			top: calc(100vw * 4 / 16);
			right: calc(100vw / 16);
		}
	}

	.top-section-icon {
		position: absolute;
		top: calc(100vw / 8);
		left: calc(100vw / 8);
		width: calc(100vw * 3 / 8);
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
			top: calc(100vw * 2 / 8);
			left: calc(100vw / 8);
			width: calc(100vw * 2 / 8);
		}
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			top: calc(100vw / 16);
			left: calc(100vw * 2 / 16);
			width: calc(100vw * 2 / 16);
		}
	}
`

const TopSectionWrapper = styled(GridContainer)`
	min-height: calc(100vw * 4 / 16);
	align-items: center;
	position: relative;
	z-index: 1;
	margin-top: calc(100vw * 5 / 8);
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		margin-top: calc(100vw / 8);
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: calc(100vw / 16);
		margin-top: 0;
	}

	.header-wrapper {
		margin-bottom: ${getCssSizeValue(35, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin-bottom: ${getCssSizeValue(56, BREAKPOINTS.DESKTOP)};
		}
	}

	.description {
		line-height: ${getFontSize(25.2, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
			font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
			line-height: ${getFontSize(32.4, BREAKPOINTS.TABLET)};
		}
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
			line-height: ${getFontSize(32.4, BREAKPOINTS.DESKTOP)};
		}
	}
`

const HeadingWrapper = styled(GridContainer)`
	margin-bottom: calc(100vw / 8);
	margin-top: ${getCssSizeValue(80, BREAKPOINTS.MOBILE)};
	padding-top: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	position: relative;
	z-index: 1;
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		margin-top: ${getCssSizeValue(150, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(40, BREAKPOINTS.DESKTOP)};
		padding-top: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
		margin-top: 0;
	}

	.heading {
		font-size: ${getFontSize(26, BREAKPOINTS.MOBILE)};
		line-height: ${getFontSize(39, BREAKPOINTS.MOBILE)};
		font-weight: ${({ theme }) => theme.fontWeight.medium};
		@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
			font-size: ${getFontSize(36, BREAKPOINTS.TABLET)};
			line-height: ${getFontSize(54, BREAKPOINTS.TABLET)};
		}
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			font-size: ${getFontSize(36, BREAKPOINTS.DESKTOP)};
			line-height: ${getFontSize(54, BREAKPOINTS.DESKTOP)};
		}
	}
`

const TilesWrapper = styled(GridContainerRectangles)`
	padding-left: calc(100vw / 8);
	padding-right: calc(100vw / 8);
	grid-template-columns: 1fr;
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		grid-template-columns: repeat(2, 1fr);
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		grid-template-columns: repeat(16, 1fr);
		padding-left: calc(100vw / 16);
	}
`

const SingleTileWrapper = styled.div`
	width: calc(100vw * 6 / 8);
	//aspect-ratio: 6/3;
	border: 1px solid ${({ theme }) => theme.colors.antiflashWhite};
	background-color: ${({ theme }) => theme.colors.antiflashWhite};
	color: ${({ theme }) => theme.colors.richBlack};
	//padding: 0 24px;
	padding: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)} 24px;
	display: flex;
	flex-direction: column;
	//justify-content: center;
	justify-content: flex-start;

	&:nth-child(2n) {
		background-color: ${({ theme }) => theme.colors.white};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		width: calc(100vw * 3 / 8);
		//aspect-ratio: 3/2;
		//padding: 0 27px;
		padding: ${getCssSizeValue(48, BREAKPOINTS.TABLET)} 27px;
		&:nth-child(2),
		&:nth-child(3) {
			background-color: ${({ theme }) => theme.colors.white};
		}

		&:nth-child(1),
		&:nth-child(4) {
			background-color: ${({ theme }) => theme.colors.antiflashWhite};
		}
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: calc(100vw * 3 / 16);
		//padding: 0 24px;
		padding: ${getCssSizeValue(64, BREAKPOINTS.DESKTOP)} 24px;
		//aspect-ratio: 3/2;
		aspect-ratio: unset;
		&:nth-child(2n) {
			background-color: ${({ theme }) => theme.colors.white};
		}

		&:nth-child(3) {
			background-color: ${({ theme }) => theme.colors.antiflashWhite};
		}
	}
`

const SingleTileTitleWrapper = styled.div`
	min-height: ${getCssSizeValue(56, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		min-height: ${getCssSizeValue(80, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		min-height: ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)};
	}
`

const TilesRectangleGridAdditionalTopSection = ({ data, headerDescription }) => {
	const heading = data?.heading || ""
	const topHeading = data?.topHeading || ""
	const topDescription = data?.topDescription || ""
	const topIcon = data?.topIcon?.url || ""
	const items = data?.tiles || []
	const isMobile = useIsMobile()
	const isTablet = useIsTablet()
	const rectanglesAmount = isMobile && !isTablet ? 288 : isTablet ? 120 : 160
	return (
		<TilesRectangleGridAdditionalTopSectionContainer>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<BackgroundGrid>
				{[...new Array(rectanglesAmount)].map((_, key) => (
					<div className="grid-item" key={`block-${key}`} />
				))}
				<Icon1 className="icon icon-1" />
				<img className="top-section-icon" src={topIcon} alt="icon" />
			</BackgroundGrid>
			<TopSectionWrapper className="indent-desktop-6 indent-tablet-4">
				<div className="col-mobile-8 col-tablet-5 col-desktop-9">
					<div
						className="header-wrapper typo-borna typo-borna-91"
						dangerouslySetInnerHTML={getHtmlFromRedactorField(topHeading)}
					/>
					<div
						className="typo-borna typo-borna-11 description"
						dangerouslySetInnerHTML={getHtmlFromRedactorField(topDescription)}
					/>
				</div>
			</TopSectionWrapper>
			<HeadingWrapper className="indent-desktop-1 indent-tablet-1 col-mobile-8 col-tablet-6 col-desktop-10">
				<div
					className="typo-borna typo-borna-89 heading col-mobile-8 col-tablet-6 col-desktop-10"
					dangerouslySetInnerHTML={getHtmlFromRedactorField(heading)}
				/>
			</HeadingWrapper>
			<TilesWrapper className="indent-desktop-1">
				{items.map((item) => {
					return (
						<SingleTileWrapper key={item.text}>
							{item?.title && (
								<SingleTileTitleWrapper>
									<div
										className="typo-strawford typo-strawford-92"
										dangerouslySetInnerHTML={getHtmlFromRedactorField(item?.title || "")}
									/>
								</SingleTileTitleWrapper>
							)}
							<div
								className="typo-strawford typo-strawford-92"
								dangerouslySetInnerHTML={getHtmlFromRedactorField(item?.text || "")}
							/>
						</SingleTileWrapper>
					)
				})}
			</TilesWrapper>
		</TilesRectangleGridAdditionalTopSectionContainer>
	)
}

export default TilesRectangleGridAdditionalTopSection
